<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box">
      <all-user ref="allUser" @usernameChange="usernameChange"></all-user>
    </div>
    <div class="select-box input_left">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入小程序名称" :rows="4" />
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchAppVer" style="width:150px;" placeholder="请输入版本号" :rows="4" />
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box-type-pl" v-show="tableType === 1">
      <Select v-model="plType" style="width:150px" @on-change="changePlType" placeholder="请选择批量操作">
        <Option value="1" key="1">批量提交审核</Option>
        <Option value="2" key="2">批量发布上线</Option>
        <Option value="3" key="3">批量版本回退</Option>
      </Select>
      <Input v-model="searchPackageName" style="width:150px;margin-left:17px;" placeholder="请输入包名" :rows="4" />
      <Select v-model="searchAuditStatus" style="width:150px;margin-left:17px;" placeholder="审核状态">
        <!-- <Option value="0" key="0">未提审</Option> -->
        <Option value="1" key="1">待审核</Option>
        <Option value="2" key="2">审核通过</Option>
        <Option value="3" key="3">审核驳回</Option>
      </Select>
      <Select v-model="searchAppStatus" style="width:150px;margin-left:17px;" @on-change="changePlType" placeholder="应用状态">
        <Option value="1" key="1">启用</Option>
        <Option value="2" key="2">未启用</Option>
      </Select>
      <Button type="primary" @click="newAlert" style="margin-left:96px;">添加新应用</Button>
    </div>
    <div class="select-box-type">
      <Select v-model="tableType" style="width:100px" @on-change="changeTableType">
        <Option :value="0" key="0">图标</Option>
        <Option :value="1" key="1">列表</Option>
      </Select>
    </div>
    <Scroll style="margin-top:20px;" v-show="tableType === 0" :height="scrollHeight" :on-reach-bottom="handleReachBottom">
    <div class="app-list">
       <div v-if="isShowSpin" class="card-spin-container">
          <Spin fix></Spin>
      </div>
      <Card class="app-item">
        <div class="app-add" @click="newAlert">
          <Icon type="md-add" size="100" />
          <p>添加新应用</p>
        </div>
      </Card>
      <Card class="app-item" :id="'scroll' + item.id" v-for="(item, index) in dataList" :key="index">
        <div class="text-center">
          <div class="app-info">
            <img :src="item.icon">
            <h3>{{item.name}}</h3>
            <p><strong style="color: #19be6b">{{item.package_stats}}</strong> {{item.package_ver}}</p>
            <p>{{item.update_at}}</p>
            <Tag color="primary" class="app_aduit_stats">{{aduitText(item.aduit_stats)}}</Tag>
            <Tag :color="item.state === 1 ? 'primary' : 'warning'" class="app_close_stats">{{item.state === 1 ? '已启用' : '未启用'}}</Tag>
          </div>
          <div class="app-option" style="overflow:hidden">
            <div class="option-item" v-if="item.aduit_stats !== 1 && item.uid === userId" @click="newAlert(index)">
              <div class="item-icon"><Icon size="25" type="md-create" /></div>
              <p>编辑</p>
            </div>
            <div class="option-item" @click="gotoScroll(item)" :to="{name: 'version', query: {tvid: item.id, icon: item.icon, name: item.name, package_name: item.package_name, id: item.id, uid: item.uid}}">
              <div class="item-icon"><Icon size="25" type="md-cloud-upload" /></div>
              <p>版本管理</p>
            </div>
            <div v-if="userAccount.id !== 1">
              <Button type="primary" v-show="item.payment_status === 0" @click="applyPayAlert(index)">申请支付功能</Button>
              <Button type="primary" v-show="item.payment_status === 1" :disabled="true">支付功能申请中...</Button>
              <Button type="primary" v-show="item.payment_status === 2" @click="copyStr(item.pay_key)">复制：{{item.pay_key}}</Button>
              <Button type="primary" v-show="item.payment_status === 3" @click="applyPayAlert(index)">重新申请支付功能</Button>
            </div>
            <input type="text" id="copyinput"/>
          </div>
        </div>
      </Card>
    </div>
    </Scroll>
    <div class="app-list-table" v-show="tableType === 1">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
          <!-- :page-size-opts="pageOpts" -->
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    <div v-for="(item,index) in batchErrArr" :key="index">
      {{item.name}}---{{item.message}}
    </div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPush"
      title="批量提交审核"
      @on-ok="editDataPL('formValidatePl')"
      @on-cancel="cancelModal"
      >
      <!-- <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量审核版本号" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form> -->
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPublish"
      title="批量发布"
       @on-ok="editDataPL('formValidatePl')"
       @on-cancel="cancelModal"
      >
      <!-- <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量发布版本号" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form> -->
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plBack"
      title="批量回退"
       @on-ok="editDataPL('formValidatePl')"
       @on-cancel="cancelModal"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="200">
        <FormItem label="批量回退版本号到上一版本号" prop="name">
          <!-- <Input v-model="formValidatePl.ver" placeholder="请输入版本号" /> -->
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :footer-hide="editFlag === 'true'?true:false"
      :title="editId ? editFlag === 'true' ? '查看应用' : '编辑应用' : '新建应用'"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="应用名称" prop="name">
          <Input v-model="formValidate.name" :disabled="editFlag === 'true'" placeholder="请输入应用名称，2-20个字" />
        </FormItem>
        <FormItem label="应用包名" prop="package_name" :rules="[{ required: !editId, message: '请输入应用包名', trigger: 'blur' }]">
          <Input v-model="formValidate.package_name" :disabled="editId !== ''" :readonly="!!editId" placeholder="请输入小程序包名" />
          <div class="tips">应用包名创建后不可修改，例如es.huxiaobao.vip。</div>
        </FormItem>
        <FormItem label="方形Icon" prop="fileName" :rules="[{required: !editId, message: '请上传小程序Icon', trigger: 'blur'}]">
          <label class="file-wrap">
            <input class="file-input" type="file" ref="file" accept="image/*" @change="uploadImg('file')" />
            <Button :disabled="editFlag === 'true'" icon="ios-cloud-upload-outline">{{formValidate.fileName || '上传'}}</Button>
          </label>
          <div class="icon-preview" v-show="formValidate.icon">
            <div class="icon-preview__title">当前小程序Icon</div>
            <img class="icon-preview__img" :src="formValidate.icon" alt="当前小程序Icon" draggable="false">
          </div>
        </FormItem>
        <FormItem label="圆形Icon" prop="fileName2" :rules="[{required: !editId, message: '请上传小程序圆角Icon', trigger: 'blur'}]">
          <label class="file-wrap">
            <input class="file-input" type="file" ref="fileRadius" accept="image/*" @change="uploadImgRadius('fileRadius')" />
            <Button :disabled="editFlag === 'true'" icon="ios-cloud-upload-outline">{{formValidate.fileName2 || '上传'}}</Button>
          </label>
          <div class="icon-preview" v-show="formValidate.circleLogo">
            <img class="icon-preview__img" :src="formValidate.circleLogo" alt="当前圆角Icon" draggable="false">
          </div>
        </FormItem>
        <FormItem v-show="editId" label="最低可用版本" prop="min_ver">
          <Select
                v-model="formValidate.min_ver"
                placeholder="请选择版本"
                filterable
                :disabled="true"
                >
                <Option v-for="(option, index) in minVerList" :value="option.package_ver" :tag="option" :key="index">{{option.package_ver}}</Option>
            </Select>
            <p>最低可用版本弃用</p>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" :disabled="editFlag === 'true'" type="textarea" :rows="4" />
        </FormItem>
        <FormItem v-if="formValidate.aduit_stats === 3" label="未通过原因" prop="aduit_con">
          <Input v-model="formValidate.aduit_con" :disabled="editFlag === 'true'" readonly type="textarea" :rows="4" />
        </FormItem>
        <div class="option-item" v-if="formValidate.aduit_stats === 2" style="margin-left:24px;">
              <div class="option-top">
                应用是否启用:
                <i-switch :disabled="editFlag === 'true'" :value="formValidate.state === 1" @on-change="switchChange" true-color="#13ce66" />
              </div>
            </div>
        <Button v-if="editId" :disabled="editFlag === 'true'" type="primary" style="margin-left:236px;" @click="delCurrentApp">删除当前应用</Button>
      </Form>
    </Modal>

    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowApplyPay"
      title="完善支付相关信息"
      @on-ok="applyData('formPayValidate')">
      <Form ref="formPayValidate" :model="formPayValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="应用名称" prop="apk_name">
          <Input v-model="formPayValidate.apk_name" placeholder="请输入商店上架应用名称，2-20个字" />
        </FormItem>
        <FormItem label="小程序包名" prop="app_pkg">
          <Input v-model="formPayValidate.app_pkg" :disabled="true" placeholder="请输入小程序包名，创建后不可修改。需以es. 开头，例如tv.huan.vibes.test" />
        </FormItem>
        <FormItem label="商店上架包名" prop="apk_pkg">
          <Input v-model="formPayValidate.apk_pkg" :disabled="appPkgFlag" placeholder="商店上架包名,例如tv.huan.vibes.test" />
          <div class="tips">提示小程序包名创建后不可修改，仅支持小写英文，需遵循三段或以上分段式</div>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="800"
      :mask-closable="false"
      v-model="isShowAgreement"
      title=""
      :footer-hide="true"
      >
      <div class="agreement_title">分成协议</div>
      <div class="agreement_text">
        <!-- 55分成XXX协55分成XXX协议55分成XXX协议55分成XXX协
        议55分成XXX协议55分成XXX协议55分成XXX协议55分成XX
        X协议55分成XXX协议55分成XXX协议55分成XXX协议55分成XX -->
      </div>
      <div style="margin-left:300px;">
        <Checkbox  v-model="single">已阅读并同意协议中的内容</Checkbox>
      <Button type="primary" :disabled="!single" @click="checkAgreement">签署该协议并申请开通支付</Button></div>
    </Modal>
    <!-- isShowAgreement -->
    <verify-modal ref="verify"></verify-modal>
    <icon-cropper v-model="iconCropperVisible" :src="iconCropperSrc" @select="onIconCropperSelect"></icon-cropper>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import verifyModal from '@/components/global/verifyModal'
import allUser from '@/components/global/allUser'
import IconCropper from '@/components/global/IconCropper'
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      tableType: 0,
      mobileApp: [],
      // pageOpts: [10, 20, 30, 40, 100],
      editId: '',
      editItem: '',
      userId: '',
      userList: [],
      searchAppName: '',
      searchAppVer: '',
      searchPackageName: '',
      searchAuditStatus: '',
      searchAppStatus: '',
      currentIndex: '',
      isShowApplyPay: false,
      isShowAgreement: false,
      single: false,
      isShowSpin: false,
      userAccount: {},
      iconPreviewObjectUrl: '',
      circleIconPreviewObjectUrl: '',
      iconCropperVisible: false,
      iconCropperSrc: '',
      iconCropperObjectUrl: '',
      plType: 0,
      plPush: false,
      plPublish: false,
      plBack: false,
      tableSelectRow: [],
      batchErrArr: [],
      batchErrArrFlag: false,
      searchName: '',
      formValidatePl: {
        ver: ''
      },
      formValidate: {
        name: '',
        remark: '',
        package_name: '',
        circleLogo: '',
        icon: '',
        files: '',
        fileName: '',
        files2: '',
        fileName2: '',
        pre_pwd: ''
      },
      minVerList: [],
      formPayValidate: {
        app_pkg: '',
        apk_name: '',
        apk_pkg: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 20, min: 2, message: '请输入2-20个字', trigger: 'blur' }
        ],
        pre_pwd: [
          { required: false, message: '请输入预览密码', trigger: 'blur' },
          { type: 'string', max: 32, message: '长度最多32位', trigger: 'blur' }
        ],
        // apk_pkg: { required:true,pattern:/^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g , message:'示例：tv.huan.vibes.test。' }
        apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '应用名称',
          key: 'name',
          width: 150,
          align: 'center'
        },
        {
          title: '方形icon',
          key: 'icon',
          width: 90,
          render: (h, params) => {
            return h('img', {attrs: {
              src: params.row.icon
            },
            style: {
              width: '50px',
              height: '50px',
              marginTop: '10px'
            }
            })
          }
        },
        {
          title: '圆角icon',
          key: 'circleLogo',
          width: 90,
          render: (h, params) => {
            if (params.row.circleLogo) {
              return h('img', {attrs: {
                src: params.row.circleLogo
              },
              style: {
                width: '50px',
                height: '50px',
                marginTop: '10px'
              }
              })
            } else {
              return h('div')
            }
          }
        },
        {
          title: '包名',
          key: 'package_name',
          width: 200
        },
        {
          title: '审核状态',
          key: 'aduit_stats',
          width: 200,
          render: (h, params) => {
            let aduit_stats = ''
            switch (params.row.aduit_stats) {
              case 0:
                aduit_stats = '未提审'
                break
              case 1:
                aduit_stats = '待审核'
                break
              case 2:
                aduit_stats = '审核通过'
                break
              case 3:
                aduit_stats = '审核驳回'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.verify.show(params.row, 'app', 'app')
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '应用状态',
          key: 'state',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let aduit_stats = ''
            if (params.row.state === 1) {
              aduit_stats = '启用'
            } else {
              aduit_stats = '不启用'
            }
            return h('span', aduit_stats)
          }
        },
        {
          title: '线上最新版本',
          key: 'package_ver',
          align: 'center',
          width: 150
        },
        {
          title: '最低可用版本',
          key: 'min_ver',
          align: 'center',
          width: 150
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          width: 150
        },
        {
          title: '驳回原因',
          key: 'aduit_con',
          align: 'center',
          width: 200
        },
        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          minWidth: 150
        },
        {
          title: '最后更新时间',
          key: 'updated_at',
          align: 'center',
          minWidth: 150
        },
        {
          title: '操作',
          width: 420,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.aduit_stats === 1 || params.row.uid !== this.userId)
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'edit')
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'look')
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.setTableType()
                    this.$router.push({
                      path: `/developer/version`,
                      query: {
                        tvid: params.row.id,
                        icon: params.row.icon,
                        name: params.row.name,
                        table: this.tableType,
                        package_name: params.row.package_name,
                        aduit_stats: params.row.aduit_stats,
                        id: params.row.id,
                        uid: params.row.uid
                      }
                    })
                  }
                }
              }, '版本管理'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.applyPayAlert(params.index)
                  }
                }
              }, '支付申请'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.delItem(params.index)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      mobileData: {
        id: '',
        name: '',
        app_rel: []
      },
      appPkgFlag: false,
      editFlag: 'false',
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 40, // 每页多少条
      current: 1, // 当前页
      t1: 0,
      t2: 0,
      timer: null,
      scrollHeight: 600
    }
  },
  components: {
    breadcrumb,
    verifyModal,
    allUser,
    IconCropper
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.role_id = window.localStorage.getItem('role_id')
    this.tableType = Number(sessionStorage.getItem('tableType'))
    if (this.tableType === 1) {
      this.pageSize = 10
    }
    setTimeout(() => {
      this.userId = Number(window.localStorage.getItem('userId'))
      this.getUserList()
      this.getAccount()
      this.loadData()
      this.handleElementHeight()
    }, 1000)
  },
  mounted () {
    setTimeout(() => {
      let scroll_top_xy = sessionStorage.getItem('scroll_top_apk')
      if (scroll_top_xy) {
        let oA = document.createElement('a')
        oA.href = '#scroll' + scroll_top_xy
        oA.click()
      }
    }, 100)
  },
  methods: {
    handleElementHeight () {
      const scrollbarHeight = document.documentElement.clientHeight
      this.scrollHeight = (scrollbarHeight - 246)
    },
    handleReachBottom () {
      return new Promise(resolve => {
        // setTimeout(() => {
        this.current = this.current + 1
        this.loadData('reach')
        resolve()
        // }, 300)
      })
    },
    usernameChange (val) {
      this.searchName = val
      this.loadData()
    },
    getMinVer (state = '') {
      let params = {
        page_size: '100',
        page: '1',
        sort: 'updated_at desc',
        tvid: this.editId,
        query: state
      }
      https.request({
        method: 'get',
        url: '/v2/es/app/vers',
        params: params
      }).then(res => {
        // this.tableLoading = false
        res.data.items.map(item => {
          if (item.package_stats > 1) {
            this.minVerList.push(item)
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    cancelModal () {
      this.plType = 0
    },
    changePlType () {
      if (this.plType === '1') {
        console.log('批量提交')
        this.plPush = true
      } else if (this.plType === '2') {
        console.log('批量发布')
        this.plPublish = true
      } else if (this.plType === '3') {
        console.log('批量版本回退')
        this.plBack = true
      }
    },
    applyPayAlert (index) {
      if (this.userAccount.qualification_type === 2) {
        if (this.userAccount.qualification_status === 0 || this.userAccount.qualification_status === 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请先去资质审核',
            onOk: () => {
              this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else if (this.dataList[index].aduit_stats !== 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请去审核应用',
            onOk: () => {
              // this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else {
          // this.getStroePkgName(this.dataList[index].package_name)
          console.log(this.dataList, index)
          if (this.dataList[index].package_stats !== '线上版本') {
            this.$Modal.confirm({
              title: '提示',
              content: '请先去选择版本上线',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          if (this.dataList[index].store_pkg_name.length === 0) {
            this.$Modal.confirm({
              title: '提示',
              content: '请先在欢视商店提交上架',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          this.isShowApplyPay = true
          this.appPkgFlag = true
          this.formPayValidate = {
            // app_pkg: this.dataList[index].package_name,
            // apk_pkg: this.dataList[index].sd_pkg_name,
            app_pkg: this.dataList[index].package_name,
            apk_pkg: this.dataList[index].store_pkg_name,
            apk_name: this.dataList[index].store_app_name
          }
        }
      } else if (this.userAccount.qualification_type === 1) {
        if (this.userAccount.qualification_status === 0 || this.userAccount.qualification_status === 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请先去资质审核',
            onOk: () => {
              this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else if (this.dataList[index].aduit_stats !== 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请去审核应用',
            onOk: () => {
              // this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else {
          // this.getStroePkgName(this.dataList[index].package_name)
          console.log(this.dataList, index)
          if (this.dataList[index].package_stats !== '线上版本') {
            this.$Modal.confirm({
              title: '提示',
              content: '请先去选择版本上线',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          if (this.dataList[index].store_pkg_name.length === 0) {
            this.$Modal.confirm({
              title: '提示',
              content: '请先在欢视商店提交上架',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          this.isShowApplyPay = true
          this.appPkgFlag = true
          this.formPayValidate = {
            apk_name: this.dataList[index].store_app_name,
            app_pkg: this.dataList[index].package_name,
            apk_pkg: this.dataList[index].store_pkg_name
          }
        }
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '请先去资质审核',
          onOk: () => {
            this.$router.push('certification')
          },
          onCancel: () => {
          }
        })
      }
    },
    getStroePkgName (id) {
      https.request({
        method: 'get',
        url: '/v2/es/app/storepkgname',
        params: {
          es_pkg_name: id
        }
      }).then(res => {
        if (res.data.store_pkg_name.length === 0) {
          this.appPkgFlag = false
        } else {
          this.appPkgFlag = true
          this.formPayValidate.apk_pkg = res.data.store_pkg_name
        }
      })
    },
    setTableType () {
      sessionStorage.setItem('tableType', this.tableType)
    },
    gotoScroll (item) {
      sessionStorage.setItem('scroll_top_apk', item.id)
      this.setTableType()
      this.$router.push({
        path: `/developer/version`,
        query: {
          tvid: item.id,
          icon: item.icon,
          name: item.name,
          package_name: item.package_name,
          table: this.tableType,
          id: item.id,
          uid: item.uid
        }
      })
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchAppVer = ''
      this.searchPackageName = ''
      this.searchAuditStatus = ''
      this.searchAppStatus = ''
      this.$refs.allUser.clear()
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    changeTableType (val) {
      this.dataList = []
      this.tableType = val
      this.current = 1
      this.setTableType()
      if (val === 0) {
        this.pageSize = 40
      } else {
        this.pageSize = 10
      }
      this.loadData()
    },
    getUserNameAuth () {
      let userNameAuth = sessionStorage.getItem('user_name_auth')
      if (userNameAuth !== null) {
        this.userList.map(item => {
          if (item.label === userNameAuth) {
            this.loadData(item.value)
            sessionStorage.removeItem('user_name_auth')
          }
        })
      }
    },
    getUserList () {
      let params = {
        page_size: 200,
        page: 1
      }
      https.request({
        method: 'get',
        url: '/v1/account/',
        params: params
      }).then(res => {
        res.data.list.map(item => {
          this.userList.push({
            value: item.id,
            label: item.username
          })
        })
        this.getUserNameAuth()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 加载tabs列表
    loadData (type = 'no') {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        uid: this.searchName,
        name: this.searchAppName,
        package_ver: this.searchAppVer,
        package_name: this.searchPackageName || null,
        audit_stats: this.searchAuditStatus || null,
        status: this.searchAppStatus || null
        // username: this.searchName
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        // url: 'v2/es/apps',
        url: 'extscreenapi/plugin/hili/v2/es/apps',
        params: params
      }).then(res => {
        this.tableLoading = false
        this.isShowSpin = false
        res.data.items.forEach(n => {
          if (n.state === 2) {
            n.app_status = '已禁用'
          } else if (n.aduit_stats === 1) {
            n.app_status = '应用待审核'
          } else if (n.aduit_stats === 3) {
            n.app_status = '审核未通过'
          } else if (n.aduit_stats === 2 && n.package_ver) {
            n.app_status = '已上线'
          }
        })
        res.data.items.forEach(n => {
          if (n.package_stats === 0) {
            n.package_stats = '未发布'
          } else if (n.package_stats === 1) {
            n.package_stats = '测试版本'
          } else if (n.package_stats === 2) {
            n.package_stats = '线上版本'
          } else if (n.package_stats === 3) {
            n.package_stats = '历史版本'
          }
        })
        if (this.tableType === 0) {
          if (type === 'no') {
            this.dataList = res.data.items
          } else {
            this.dataList = [...this.dataList, ...res.data.items]
          }
        } else {
          this.getUserNameFun(res.data.items)
        }
        // this.dataList = res.data.items
        this.total = res.data.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.uid)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (Number(item.value) === sItem.uid) {
              sItem['userName'] = item.text
            }
          })
        })
        // setTimeout(() => {
        this.dataList = list
        this.updateChecked()
        // }, 500)
      })
    },
    updateChecked () {
      for (var i = 0; i < this.dataList.length; i++) {
        this.dataList[i]._checked = false
        if (this.dataList[i].uid !== Number(this.userId)) {
          this.dataList[i]._disabled = true
        }
        for (var j = 0; j < this.tableSelectRow.length; j++) {
          if (this.tableSelectRow[j].id === this.dataList[i].id) {
            this.dataList[i]._checked = true
          }
        }
      }
    },
    onCopy () {

    },
    switchChange (val) {
      console.log(val)
      if (val) {
        this.formValidate.state = 1
        console.log(val)
      } else {
        this.formValidate.state = 2
      }
    },
    uploadImg (name) {
      let file = this.$refs[name].files[0]
      // console.log('1',file)
      if (!file) return
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.$Message.error('请选择图片文件（PNG/JPG/SVG）')
        this.$refs[name].value = ''
        return
      }
      this.formValidate.files = file
      this.formValidate.fileName = file.name
      if (this.iconPreviewObjectUrl) {
        URL.revokeObjectURL(this.iconPreviewObjectUrl)
        this.iconPreviewObjectUrl = ''
      }
      this.iconPreviewObjectUrl = URL.createObjectURL(file)
      this.formValidate.icon = this.iconPreviewObjectUrl
      this.openIconCropper()
    },
    uploadImgRadius (name) {
      let file = this.$refs[name].files[0]
      // console.log('2',file)
      if (!file) return
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.$Message.error('请选择图片文件（PNG/JPG/SVG）')
        this.$refs[name].value = ''
        return
      }
      this.formValidate.files2 = file
      this.formValidate.fileName2 = file.name
      if (this.circleIconPreviewObjectUrl) {
        URL.revokeObjectURL(this.circleIconPreviewObjectUrl)
        this.circleIconPreviewObjectUrl = ''
      }
      this.circleIconPreviewObjectUrl = URL.createObjectURL(file)
      this.formValidate.circleLogo = this.circleIconPreviewObjectUrl
    },
    openIconCropper () {
      if (!this.formValidate.icon) return
      if (this.iconCropperObjectUrl) {
        URL.revokeObjectURL(this.iconCropperObjectUrl)
        this.iconCropperObjectUrl = ''
      }
      const src = this.formValidate.icon
      if (/^https?:\/\//i.test(src)) {
        fetch(src).then(res => res.blob()).then(blob => {
          this.iconCropperObjectUrl = URL.createObjectURL(blob)
          this.iconCropperSrc = this.iconCropperObjectUrl
          this.iconCropperVisible = true
        }).catch(() => {
          this.iconCropperSrc = src
          this.iconCropperVisible = true
        })
        return
      }
      this.iconCropperSrc = src
      this.iconCropperVisible = true
    },
    onIconCropperSelect (payload) {
      if (!payload || !payload.circle || !payload.rounded) return
      if (this.circleIconPreviewObjectUrl) {
        URL.revokeObjectURL(this.circleIconPreviewObjectUrl)
        this.circleIconPreviewObjectUrl = ''
      }
      if (this.iconPreviewObjectUrl) {
        URL.revokeObjectURL(this.iconPreviewObjectUrl)
        this.iconPreviewObjectUrl = ''
      }
      this.formValidate.icon = payload.rounded.dataUrl
      this.formValidate.circleLogo = payload.circle.dataUrl
      this.formValidate.files = payload.rounded.file
      this.formValidate.fileName = payload.rounded.file.name
      this.formValidate.files2 = payload.circle.file
      this.formValidate.fileName2 = payload.circle.file.name
    },
    delCurrentApp () {
      this.delItem(this.currentIndex)
      this.newdata = false
    },
    newAlert (index, type = 'edit') {
      this.$refs['formValidate'].resetFields()
      if (this.iconPreviewObjectUrl) {
        URL.revokeObjectURL(this.iconPreviewObjectUrl)
        this.iconPreviewObjectUrl = ''
      }
      if (this.circleIconPreviewObjectUrl) {
        URL.revokeObjectURL(this.circleIconPreviewObjectUrl)
        this.circleIconPreviewObjectUrl = ''
      }
      if (this.iconCropperObjectUrl) {
        URL.revokeObjectURL(this.iconCropperObjectUrl)
        this.iconCropperObjectUrl = ''
      }
      if (!isNaN(index)) {
        this.editId = this.dataList[index].id
        this.getMinVer()
        this.formValidate = {
          name: this.dataList[index].name,
          remark: this.dataList[index].remark,
          package_name: this.dataList[index].package_name,
          icon: this.dataList[index].icon,
          circleLogo: this.dataList[index].circleLogo,
          aduit_stats: this.dataList[index].aduit_stats,
          aduit_con: this.dataList[index].aduit_con,
          pre_pwd: this.dataList[index].pre_pwd,
          min_ver: this.dataList[index].min_ver,
          files: '',
          files2: '',
          fileName: '',
          fileName2: '',
          state: this.dataList[index].state,
          id: this.dataList[index].id
        }
        console.log(this.formValidate)
        this.editItem = this.dataList[index]
        console.log(type)
        this.editFlag = this.dataList[index].uid === this.userId ? type === 'edit' ? 'false' : 'true' : 'true'
        this.currentIndex = index
      } else {
        this.editId = ''
        this.editFlag = 'false'
        this.editItem = ''
        this.formValidate.files = ''
        this.formValidate.files2 = ''
        this.formValidate.circleLogo = ''
        this.formValidate.icon = ''
        this.formValidate.aduit_stats = ''
      }
      this.newdata = true
    },
    applyData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.userAccount.qualification_type === 1) {
            this.checkAgreement()
          } else if (this.userAccount.qualification_type === 2) {
            this.isShowAgreement = true
          }
        }
      })
    },
    checkAgreement () {
      https.request({
        method: 'post',
        url: '/v2/es/audit/payment',
        data: this.formPayValidate
      }).then(res => {
        console.log(res)
        if (res.code === 400) {
          if (res.message === '该小程序不属于当前账号, 无法提交申请') {
            this.$Message.error(res.message)
          } else {
            this.$Message.error(res.message)
          }
        }
        this.isShowAgreement = false
        this.isShowApplyPay = false
        this.single = false
        this.loadData()
        this.formPayValidate = {}
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    editDataPL (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.tableSelectRow.length === 0) {
            this.plType = '0'
            this.$Message.error('请先选择应用')
            this.tableSelectRow = []
            return
          }
          let arr = []
          this.tableSelectRow.map(item => {
            arr.push(item.id)
          })
          let params = new FormData()
          // params.append('ver', this.formValidatePl.ver)
          params.append('type', this.plType)
          params.append('ids', arr)
          https.request({
            method: 'put',
            url: '/v2/es/app/vers/batch',
            data: params
          }).then(res => {
            this.formValidatePl.ver = ''
            // if (this.plType === '3') {
            //   this.$Message.success('批量回退版本成功')
            // } else if (this.plType === '2') {
            //   this.$Message.success('批量发布成功')
            // } else if (this.plType === '1') {
            //   this.$Message.success('批量提交成功')
            // }
            this.tableSelectRow = []
            this.loadData()
            let errArr = []
            res.data.map(item => {
              this.dataList.map(dItem => {
                if (dItem.id === item.id) {
                  errArr.push({
                    name: dItem.name,
                    message: item.message
                  })
                }
              })
            })
            let arr = []
            errArr.map(item => {
              if (item.message === 'OK') {
                arr.unshift(item)
              } else {
                arr.push(item)
              }
            })
            this.batchErrArr = arr
            console.log(this.batchErrArr)
            if (errArr.length > 0) {
              this.batchErrArrFlag = true
            }
            this.plType = 0
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    clearErrArr () {
      this.batchErrArrFlag = false
      this.batchErrArr = []
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = new FormData()
            params.append('name', this.formValidate.name)
            if (this.formValidate.fileName) params.append('icon', this.formValidate.files)
            if (this.formValidate.fileName2) params.append('corner', this.formValidate.files2)
            if (this.formValidate.pre_pwd) params.append('pre_pwd', this.formValidate.pre_pwd)
            params.append('remark', this.formValidate.remark)
            if (this.editId) {
              params.append('status', this.formValidate.state)
              params.append('id', this.editId)
              params.append('min_ver', this.formValidate.min_ver)
              https.request({
                method: 'put',
                url: '/v2/es/app',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  console.log(res.message)
                  this.$Message.error(res.message)
                  this.newdata = false
                  this.loadData()
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              params.append('package_name', this.trim(this.formValidate.package_name))
              https.request({
                method: 'post',
                url: '/v1/tvp/add',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                data: params
              }).then(res => {
                console.log(res)
                if (res.data && res.data.code === 400) {
                  this.$Message.error(res.data.msg)
                  return
                }
                this.$Message.success('提交成功')
                setTimeout(() => {
                  this.newdata = false
                  this.loadData()
                }, 1000)
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    trim (str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    delItem (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].name + '</span> 吗？</p>',
        onOk: () => {
          if (this.dataList[index].is_sync) {
            this.$Message.error('同步小程序不可删除')
            return
          }
          https.request({
            method: 'GET',
            url: '/v1/tvp/del',
            params: {
              id: this.dataList[index].id
            }
          }).then(res => {
            this.$Message.success('删除成功')
            if (this.dataList.length === 1 && this.current > 1) this.current -= 1
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    getAccount () {
      // /v2/es/account
      https.request({
        method: 'GET',
        url: '/v2/es/account',
        params: {}
      }).then(res => {
        console.log(res)
        this.userAccount = res.data
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    copyStr (str) {
      console.log(str)
      const input = document.querySelector('#copyinput')
      input.value = str
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$Message.success('复制成功')
        // input.value = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .icon-preview {
    margin-top: 8px;
    border: 1px solid #ccc;
    padding: 5px;
    // display: inline-block;
  }
  .icon-preview__img {
    display: block;
    max-width: 100px;
    height: auto;
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    // position: absolute;
    // top: 20px;
    // left: 260px;
    margin-top:20px;
    margin-left:130px;
  }
  .input_left{
    left:407px;
    // left:407px;
  }
  .input_left_two{
    left:580px;
    // left:580px;
  }
  .input_left_three{
    left:755px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:20px 0 40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/esApp/esApp.vue